export default __webpack_public_path__ + "static/img/vogue_scene_animated_0542.17120a3.jpg";